import { render, staticRenderFns } from "./supplier_deposit.vue?vue&type=template&id=2cd0b212&"
import script from "./supplier_deposit.vue?vue&type=script&lang=js&"
export * from "./supplier_deposit.vue?vue&type=script&lang=js&"
import style0 from "./supplier_deposit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports